import * as React from 'react'
import { Flex, Box } from 'grid-styled'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { Helmet } from 'react-helmet'
import Hero from '../../components/Hero'
import Button from '../../components/Button'
import BackgroundSection from '../../components/BackgroundSection'
import MainLayout from '../../components/Layout'
import { AboutContact } from '..'
import Testimonials from '../../components/Testimonials'
import {
  SportswearImages,
  StyledTabs,
  StyledTabList,
  MoreSports,
  StyledTab,
  Content
} from '../../components/procedures'
import { TabPanel } from 'react-tabs'
import { netballTestimonials } from '../testimonials'

const content = {
  subtitle: `Trusted, Experienced & Ethical. Boutique plastic surgery on Sydney's north shore.`,
  title: 'Baseball'
}

export default ({ data }) => (
  <MainLayout header="light">
    <Helmet>
      <title>Baseball - Custom Sportswear - GFit</title>
      
    </Helmet>

    <Hero
      pngImage={true}
      bgImage={data.netball.childImageSharp}
      height="400px"
      noForm={true}
    />

    <Content>
      <h2>
        On Field - <i>{content.title} Gear</i>
      </h2>
      <span>
        Take a look below to see some of our previous{' '}
        {content.title.toLowerCase()} designs.
      </span>
      <p>
        Player comfort and garment performance are always at the forefront when
        selecting our range of GFIT on field Baseball fabrics. We offer a wide
        range of lightweight fabrics all with moisture and climate control
        elements keeping your players cool and dry under extreme game day
        conditions.{' '}
      </p>
      <p>
        GFIT have worked closely with some current day players to develop the
        lightest most durable performing Baseball jerseys on the market today.
        Design options are limitless using our cutting-edge design process and
        sharp sublimation techniques. ALL LOGOS, NUMBERS AND ARTWORK ARE ADDDED
        AT NO EXTRA COST TO OUR CLIENTS ON ALL SUBLIMATION ORDERS.
      </p>
      <p>
        Call us today on 0418981023 and let GFIT help bring your design concept
        to life.
      </p>
    </Content>

    <SportswearImages>
      <div>
        {data.allFile.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return x.node.childImageSharp.fluid.src.localeCompare(
              y.node.childImageSharp.fluid.src
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Hero bgImage={data.sportsBreak.childImageSharp} height="750px">
      <h1>Do you have questions?</h1>
      <p>
        Call 0418 981 023 or please complete the enquiry form to contact us
        today and find out how we can help.
      </p>
      <Flex>
        <Button color={'#fff'} small={true} outline={true}>
          Contact Us
        </Button>
      </Flex>
    </Hero>

    <Content>
      <h2 id="training">
        Training Shirts - <i>{content.title} Gear</i>
      </h2>

      <p>
        Our performance training T- shirt range are available in a range of
        light weight fabrics which offer moisture wicking and climate control
        components to keep you dry and comfortable at training along with quick
        dry odour control treatment elements to keep you fresh after training.
        Collar choices are round neck, V- Neck or Liverpool pro collar.
        Available in the latest Men’s and Ladies cuts. Design options are
        limitless using our cutting-edge design process and sharp sublimation
        techniques. Mesh panel options available. ALL LOGOS AND ARTWORK ARE
        ADDDED AT NO EXTRA COST TO OUR CLIENTS ON ALL SUBLIMATION ORDERS.{' '}
      </p>
    </Content>

    <SportswearImages>
      <div>
        {data.trainingShirts.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Content>
      <h2 id="training">
        Training Singlets - <i>{content.title} Gear</i>
      </h2>
    </Content>

    <SportswearImages>
      <div>
        {data.trainingSinglets.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Content>
      <h2 id="training">
        Training Shorts - <i>{content.title} Gear</i>
      </h2>

      <p>
        Our performance training shorts are available in a range of light weight
        moisture wicking fabrics and the latest stretch microfibre. Mesh and
        Lycra panel or gusset options available. Design options are limitless
        using our cutting-edge design process and sharp sublimation techniques.
        Available in the latest Men’s and Ladies cuts. ALL LOGOS AND ARTWORK ARE
        ADDDED AT NO EXTRA COST TO OUR CLIENTS ON ALL SUBLIMATION ORDERS.
      </p>
      <p>
        Call us today on 0418981023 and let GFIT help bring your design concept
        to life.
      </p>
    </Content>

    <SportswearImages>
      <div>
        {data.trainingShorts.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Testimonials testimonials={netballTestimonials} />

    <Content>
      <h2 id="off-field">
        Off Field - <i>{content.title} Gear</i>
      </h2>
    </Content>

    <Content>
      <h2 id="off-field">Hoodies</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.hoodies.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
    </SportswearImages>

    <Content>
      <h2 id="off-field">Track Suit Jackets</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.trackSuits.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
    </SportswearImages>
    <Content>
      <h2 id="off-field">Quarter Zip &amp; Soft Shell</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.quarterZip.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
    </SportswearImages>
    <Content>
      <h2 id="off-field">Puffa Jackets</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.puffa.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
    </SportswearImages>
    <Content>
      <h2 id="off-field">Track Suit Pants</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.offField.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
      <Flex justifyContent="center" mt={4}>
        <Link to="/contact">
          <Button inverted={true}>
            Contact us for your free custom design today!
          </Button>
        </Link>
      </Flex>
    </SportswearImages>

    <Content>
      <h2 id="off-field">
        Off Field Polos - <i>{content.title} Gear</i>
      </h2>
      <p>
        GFIT Elite pro polo shirt range are available in a range of light weight
        fabrics which contain both moisture and climate control components, we
        offer a wide range of the latest collar options. Available in the
        stylish Men’s and Ladies pro cuts and standard cuts. Design options are
        limitless using our cutting-edge design process and sharp sublimation
        techniques. Mesh panel options available. ALL LOGOS AND ARTWORK ARE
        ADDDED AT NO EXTRA COST TO OUR CLIENTS ON ALL SUBLIMATION ORDERS.
      </p>

      <p>
        Call us today on 0418981023 and let GFIT help bring your design concept
        to life.{' '}
      </p>
    </Content>

    <SportswearImages>
      <div>
        {data.offFieldPolos.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
    </SportswearImages>

    <Content>
      <h2 id="off-field">Indigenous Polos</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.indigenous.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
    </SportswearImages>

    <Content>
      <h2 id="off-field">Fishing Polos</h2>
    </Content>

    <SportswearImages>
      <div>
        {data.fishing.edges
          .sort((x, y) => {
            if (
              x.node.childImageSharp === null ||
              y.node.childImageSharp === null
            ) {
              return 0
            }
            return (
              x.node.childImageSharp.fluid.src.localeCompare(
                y.node.childImageSharp.fluid.src
              ) * -1
            )
          })
          .map(
            image =>
              image.node.childImageSharp && (
                <figure>
                  <article>
                    <h6>Like this design?</h6>
                    <Link to="/contact">
                      <Button outline={true} small={true} color="#FF002D">
                        Get it for your team
                      </Button>
                    </Link>
                  </article>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </figure>
              )
          )}
      </div>
    </SportswearImages>

    <Box pb={5} pt={4}>
      <Flex my={4} justifyContent="center">
        <h2>Looking for another sport?</h2>
      </Flex>
      <MoreSports>
        {data.sports.edges.map(
          (image, i) =>
            image.node.childImageSharp && (
              <figure>
                <Link to={`/sport/${sportNames[i]}`}>
                  <Img fluid={image.node.childImageSharp.fluid} />
                </Link>
              </figure>
            )
        )}
      </MoreSports>
    </Box>

    <AboutContact data={data} />
  </MainLayout>
)

const sportNames = [
  'cricket',
  'hockey',
  'soccer',
  'netball',
  'touch',
  'basketball',
  'rugby-league',
  'afl',
  'hi-vis',
  'rugby-union',
  'corporate',
  'baseball',
  'schools'
]

export const query = graphql`
  query BaseballQuery {
    allFile(filter: { relativeDirectory: { eq: "baseball" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    offField: allFile(filter: { relativeDirectory: { eq: "off-field" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    hoodies: allFile(filter: { relativeDirectory: { eq: "hoodies" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    trackSuits: allFile(filter: { relativeDirectory: { eq: "track-suits" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    quarterZip: allFile(filter: { relativeDirectory: { eq: "quarter-zip" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    puffa: allFile(filter: { relativeDirectory: { eq: "puffa-jackets" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    indigenous: allFile(
      filter: { relativeDirectory: { eq: "indigenous-polos" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    fishing: allFile(filter: { relativeDirectory: { eq: "fishing" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    offFieldPolos: allFile(
      filter: { relativeDirectory: { eq: "off-field-polos" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    trainingShirts: allFile(
      filter: { relativeDirectory: { eq: "training-shirts" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    trainingSinglets: allFile(
      filter: { relativeDirectory: { eq: "training-singlets" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    trainingShorts: allFile(
      filter: { relativeDirectory: { eq: "training-shorts" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    sports: allFile(filter: { relativeDirectory: { eq: "headers" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 600, toFormat: PNG) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    netball: file(relativePath: { eq: "headers/baseball.png" }) {
      childImageSharp {
        fluid(maxWidth: 3000, quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    otherBreast: file(relativePath: { eq: "woods-woman.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implant: file(relativePath: { eq: "implant-place.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implantType: file(relativePath: { eq: "implant-type.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implantType2: file(relativePath: { eq: "cut-smooth-implant.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    implantProfile: file(relativePath: { eq: "profile.jpg" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    drSellars: file(relativePath: { eq: "about-gfit.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    sportsBreak: file(relativePath: { eq: "sports-break.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
